// extracted by mini-css-extract-plugin
module.exports = {"pin":"MBRgOD75","empty":"qP5pYOGm"};